/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dynamicSort } from "../../utils/MainHelper.js";

const initialState = {
    displayMode: "treemap",
    cacheTreeDetails: {},
    subItemsDataPerGroupCache: {},
    chartData: [],
    data: [],
    breadItems: [{
        path: "summary",
        name: "Categories"
    }],
    loadingText: false,
    subItemsIsLoading: false
};
const treemapreports = createSlice({
    name: "treemapreports",
    initialState: { ...initialState },
    reducers: {
        setSubItemsDataPerGroupCachce: (state, action) => {
            const { key, value, isDelete, deleteAll } = action.payload;
            if (deleteAll) {
                state.subItemsDataPerGroupCache = {};
            } else if (isDelete) {
                delete state.subItemsDataPerGroupCache[key];
            } else {
                state.subItemsDataPerGroupCache[key] = value;
            }
        },
        setCachceTreeDetails: (state, action) => {
            const { key, value, isDelete, deleteAll } = action.payload;
            if (deleteAll) {
                state.cacheTreeDetails = {};
            } else if (isDelete) {
                delete state.cacheTreeDetails[key];
            } else {
                state.cacheTreeDetails[key] = value;
            }
        },
        setDisplayMode: (state, action) => {
            state.displayMode = action.payload
        },
        setChartData: (state, action) => {
            state.chartData = action.payload
        },
        setData: (state, action) => {
            state.data = action.payload
        },
        setLoadingText: (state, action) => {
            state.loadingText = action.payload
        },
        setSubItemsIsLoading: (state, action) => {
            state.subItemsIsLoading = action.payload
        },
        setBreadItems: (state, action) => {
            const { mode = "push", item, idx } = action.payload
            if (mode === "push") {
                state.breadItems = [...state.breadItems, item]
            } else {
                state.breadItems = state.breadItems.filter((crum, i) => {
                    if (i <= idx) return crum
                })
            }
        },
    }
});

const { reducer, actions } = treemapreports;
export const {
    setSubItemsDataPerGroupCachce,
    setCachceTreeDetails,
    setDisplayMode,
    setChartData,
    setData,
    setLoadingText,
    setSubItemsIsLoading,
    setBreadItems,
} = actions;
export default reducer;
